import { queryOptions } from '@tanstack/react-query'
import { getPermitsByProjectId } from '@/features/city-clerk/dashboard-permit-tracking/api/permit-api'
import {
  getDashboardCounts,
  getRecentActivities,
  getRecentProjects,
  getUpcomingDeadlines,
} from './api/clerk-dashboard-api'

export const dashboardCountsQueryOptions = (cityKey: string) =>
  queryOptions({
    queryKey: ['dashboard', 'counts', cityKey] as const,
    queryFn: () => getDashboardCounts(cityKey),
    enabled: Boolean(cityKey) && cityKey !== 'new',
  })

export const dashboardProjectsQueryOptions = (cityKey: string) =>
  queryOptions({
    queryKey: ['dashboard', 'projects', cityKey] as const,
    queryFn: () => getRecentProjects(cityKey, 5),
    enabled: Boolean(cityKey) && cityKey !== 'new',
  })

export const dashboardDeadlinesQueryOptions = (cityKey: string) =>
  queryOptions({
    queryKey: ['dashboard', 'deadlines', cityKey] as const,
    queryFn: () => getUpcomingDeadlines(cityKey, 6),
    enabled: Boolean(cityKey) && cityKey !== 'new',
  })

export const dashboardProjectPermitsQueryOptions = (projectId: string) =>
  queryOptions({
    queryKey: ['dashboard', 'project-permits', projectId] as const,
    queryFn: () => getPermitsByProjectId(projectId),
    enabled: Boolean(projectId),
  })

export const dashboardActivitiesQueryOptions = (cityKey: string) =>
  queryOptions({
    queryKey: ['dashboard', 'activities', cityKey] as const,
    queryFn: () => getRecentActivities(cityKey, 6),
    enabled: Boolean(cityKey) && cityKey !== 'new',
  })
